import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import JSelectMultiUserModal from "./modal/JSelectMultiUserModal";
export default {
  name: 'JSelectMultiUser',
  components: {
    JSelectMultiUserModal: JSelectMultiUserModal
  },
  props: {
    value: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      selectList: []
    };
  },
  computed: {
    nameList: function nameList() {
      var names = [];

      for (var a = 0; a < this.selectList.length; a++) {
        names.push(this.selectList[a].name);
      }

      var nameStr = '';

      if (names.length > 0) {
        nameStr = names.join(",");
      }

      this.$emit("change", nameStr);
      return names;
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {
    handleSelect: function handleSelect() {
      this.$refs.selectModal.add();
    },
    selectReset: function selectReset() {
      this.selectList = [];
    },
    selectOK: function selectOK(data) {
      this.selectList = data;
    }
  }
};